(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lb-product-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('.lb-product-menu__close');
    if (!button) return;
    const disclosure = button.closest('header-details-disclosure');
    if (disclosure && typeof disclosure.close === 'function') {
      disclosure.close();
      disclosure.querySelector('summary').focus();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
